import { FormCheckbox } from "@apac/form-ui";
import { FormTextField } from "@apac/form-ui";
import type { FlightKey } from "@b2bportal/air-price-watch-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ActionLink } from "@hopper-b2b/ui";
import clsx from "clsx";
import {
  useWatchTripForm,
  type WatchTripResponse,
} from "./hooks/useWatchTripForm";

interface WatchTripSuccessProps {
  cn: (elementName: string) => string;
  flightKey: FlightKey;
  onSuccess: (response: WatchTripResponse) => void;
  onError?: (error: unknown) => void;
}

export const WatchTripForm = ({
  cn,
  flightKey,
  onSuccess,
  onError,
}: WatchTripSuccessProps): JSX.Element => {
  const {
    t,
    brand: { urls },
  } = useI18nContext();

  const {
    context: { form },
    handlers: { onWatchTripSubmit },
    componentProps: {
      nonstopInputProps,
      noBasicFareInputProps,
      emailInputProps,
    },
  } = useWatchTripForm({
    flightKey,
    onSuccess: (response) => {
      form.reset();
      onSuccess?.(response);
    },
    onError: (error) => {
      form.reset();
      onError?.(error);
    },
  });

  return (
    <div className={cn("watch-trip-view")}>
      <p className={cn("subtitle")}>{t("priceWatch.subtitle")}</p>
      <p className={cn("description")}>{t("priceWatch.description")}</p>

      <p className={cn("subtitle")}>{t("priceWatch.flightPreference")}</p>
      <form className={cn("form")} onSubmit={onWatchTripSubmit}>
        <FormCheckbox
          label={t("priceWatch.directFlightsOnly")}
          {...nonstopInputProps}
        />
        <FormCheckbox
          label={t("priceWatch.excludeBasicFares")}
          {...noBasicFareInputProps}
        />
        <FormTextField label={t("email")} {...emailInputProps} />

        <p className={cn("description")}>{t("priceWatch.instructions")}</p>

        <ActionLink
          className={cn("terms-and-conditions-link")}
          content={t("termsAndConditions")}
          onClick={(e) => {
            e.preventDefault();
            window.open(urls.termsAndConditions, "_blank");
          }}
        ></ActionLink>

        <button
          className={clsx(cn("cta-button"), "cta-button")}
          type="submit"
          disabled={form.formState.isSubmitting || !form.formState.isValid}
        >
          {t("priceWatch.startWatchingButtonCta")}
        </button>
      </form>
    </div>
  );
};
